import { useEffect } from "react";

export const useAnalyticsScript = ({ url, isAsync }) => {
  useEffect(() => {
    const head = document.querySelector("head");
    const script = document.createElement("script");

    script.async = isAsync;
    script.setAttribute("src", url);
    head.appendChild(script);
  }, [url, isAsync]);
};

export const updateInitializedDigitalDataForFirstPage = () => {
  window.digitalData[0] = {
    ...window.digitalData[0],
    journey: {
      name: "new-registration",
      stepNumber: "0",
      stepName: "welcome screen",
    },
  };
};

export const initializeDigitalData = () => {
  window.digitalData = window.digitalData || [];
  window.digitalData.push({
    site: {
      language: "en-gb",
      platformType: "cms",
    },
    pageInfo: {
      pageTitle: "home",
      pagePath: "/home",
    },
  });
};

export const useAnalytics = () => {
  useEffect(() => {
    if (!window.digitalData) {
      initializeDigitalData();
    }
  });
};

export const useOneTrustScript = (dataDomainScript) => {
  useEffect(() => {
    const head = document.querySelector("head");
    const script = document.createElement("script");

    script.src = process.env.REACT_APP_ONE_TRUST_SCRIPT_URL;
    script.type = "text/javascript";
    script.setAttribute("charset", "UTF-8");
    script.setAttribute("data-domain-script", dataDomainScript);
    head.appendChild(script);
  }, [dataDomainScript]);
};

export const useOneTrustFunctionScript = () => {
  useEffect(() => {
    const head = document.querySelector("head");
    const script = document.createElement("script");

    script.type = "text/javascript";
    head.appendChild(script);
    script.innerHTML = "function OptanonWrapper() { }";
  }, []);
};
